const ProfileLoading = () => {
  return (
    <div className="flex flex-col gap-4 max-w-lg">
      <div className="flex items-center gap-4">
        <div className="flex gap-1 w-full">
          <div className="skeleton h-10 w-1/2 bg-gray-200 rounded-lg"></div>
          <div className="skeleton h-10 w-1/2 bg-gray-200 rounded-lg"></div>
        </div>
      </div>
      <div className="flex flex-col gap-4 w-full mt-10">
        <div className="skeleton h-20 w-full bg-gray-200 rounded-lg"></div>
        <div className="skeleton h-20 w-full bg-gray-200 rounded-lg"></div>
        <div className="skeleton h-20 w-full bg-gray-200 rounded-lg"></div>
        <div className="skeleton h-20 w-full bg-gray-200 rounded-lg"></div>
        <div className="skeleton h-8 w-40 bg-gray-200 rounded-lg"></div>
      </div>
    </div>
  );
};

const ResultLoading = () => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col lg:flex-row gap-4 w-full">
        <div className="flex-1 skeleton h-96 w-full bg-gray-200 rounded-lg"></div>
        <div className="flex-[2] grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="skeleton h-20 lg:h-44 w-full bg-gray-200 rounded-lg"></div>
          <div className="skeleton h-20 lg:h-44 w-full bg-gray-200 rounded-lg"></div>
          <div className="skeleton h-20 lg:h-44 lg:mt-4 w-full bg-gray-200 rounded-lg"></div>
          <div className="skeleton h-20 lg:h-44 lg:mt-4 w-full bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};

const BasicInfoLoading = () => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col lg:flex-row gap-4 w-full">
        <div className="flex-1 skeleton h-96 w-full bg-gray-200 rounded-lg lg:flex hidden"></div>
        <div className="flex-1 flex flex-col gap-4">
          <div className="skeleton h-20 mb-1 w-full bg-gray-200 rounded-lg"></div>
          <div className="skeleton h-20 mb-1 w-full bg-gray-200 rounded-lg"></div>
          <div className="skeleton h-20 mb-1 w-full bg-gray-200 rounded-lg"></div>
          <div className="skeleton h-20 w-full bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};

const RecordsLoading = () => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col lg:flex-row gap-4 w-full">
        <div className="flex-1 skeleton h-96 w-full bg-gray-200 rounded-lg lg:flex hidden"></div>
        <div className="flex-[2] flex flex-col gap-3">
          <div className="skeleton h-36 mb-1 w-full bg-gray-200 rounded-lg"></div>
          <div className="skeleton h-36 mb-1 w-full bg-gray-200 rounded-lg"></div>
          <div className="skeleton h-36 mb-1 w-full bg-gray-200 rounded-lg"></div>
          <div className="skeleton h-36 w-full bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};

const SimpleTextLoading = () => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="skeleton h-36 mb-1 w-full bg-gray-200 rounded-lg"></div>
      <div className="skeleton h-36 mb-1 w-full bg-gray-200 rounded-lg"></div>
    </div>
  );
};

const Loading = ({ type }: { type?: string }) => {
  return (
    <div className="mx-auto w-full">
      {type === "profile" ? (
        <ProfileLoading />
      ) : type === "test-result" ? (
        <ResultLoading />
      ) : type === "basic-info" ? (
        <BasicInfoLoading />
      ) : type === "records" ? (
        <RecordsLoading />
      ) : (
        <SimpleTextLoading />
      )}
    </div>
  );
};

export default Loading;
